import React, { useState } from 'react';
import clsx from 'clsx';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import {
  Grid,
  Card,
  CardActionArea,
  CardMedia,
  CardContent, useMediaQuery,
} from '@material-ui/core';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';

import radioImgXS from 'assets/images/radio_xs.png';
import radioImg from 'assets/images/radio.png';
// import radioImg from 'assets/images/radio_full.jpg';
// import radioImg from 'assets/images/radio400x400_1.jpg';

import { HeartButton } from 'modules2/components';
import container from "./DetailsGridItem.container";

const useStyles = makeStyles((theme) => ({
  listItem: {
    background: theme.palette.paperColor,
    color: theme.palette.textColor,
    maxWidth: 216,
    maxHeight: 260,
    border: '1px solid',
    borderColor: theme.palette.borderColor,
    marginBottom: 10,
    borderRadius: 5,
    boxShadow: 'none',
    cursor: 'pointer',
    '&:hover': {
      // boxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.15), 0 2px 7px 0 rgba(0, 0, 0, 0.15)',
      background: theme.palette.hoverColorItem,
    },
    '&:hover $darkenLayer': {
      opacity: 1,
    },
    '&:hover $outerCircle': {
      background: `-webkit-radial-gradient(30% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.hoverColorItem} 27px)`,
      [theme.breakpoints.down('xs')]: {
        minWidth: 173,
        background: `-webkit-radial-gradient(28% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.hoverColorItem} 27px)`,
      },
      [theme.breakpoints.between('310', '350')]: {
        minWidth: 157,
        background: `-webkit-radial-gradient(30% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.hoverColorItem} 27px)`,
      },
      [theme.breakpoints.between('350', '365')]: {
        minWidth: 164,
        background: `-webkit-radial-gradient(29% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.hoverColorItem} 27px)`,
      },
      [theme.breakpoints.between('393', '410')]: {
        minWidth: 177,
        background: `-webkit-radial-gradient(28% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.hoverColorItem} 27px)`,
      },
      [theme.breakpoints.between('410', '440')]: {
        minWidth: 185,
        background: `-webkit-radial-gradient(33% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.hoverColorItem} 27px)`,
      },
      [theme.breakpoints.between('440', '480')]: {
        minWidth: 195,
        background: `-webkit-radial-gradient(35% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.hoverColorItem} 27px)`,
      },
      [theme.breakpoints.between('480', '520')]: {
        minWidth: 205,
        background: `-webkit-radial-gradient(38% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.hoverColorItem} 27px)`,
      },
      [theme.breakpoints.between('520', '560')]: {
        minWidth: 215,
        background: `-webkit-radial-gradient(41% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.hoverColorItem} 27px)`,
      },
      [theme.breakpoints.between('560', '600')]: {
        minWidth: 250,
        background: `-webkit-radial-gradient(40% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.hoverColorItem} 27px)`,
      },
    },
    [theme.breakpoints.down('xs')]: {
      width: '45%',
      maxWidth: '45%',
      maxHeight: 265,
      // display: 'flex',
      justifyContent: 'center',
      textAlign: 'center',
    },
  },
  cardWrapper: {
    width: 216,
    height: 177,
    display: 'inline-block',
    position: 'relative',
    backgroundPosition: '0px -19px',
    backgroundSize: 203,
    backgroundPositionY: -19,
    [theme.breakpoints.down('xs')]: {
      width: 170,
    },
  },
  cardImage: {
    width: 216,
    [theme.breakpoints.down('xs')]: {
      width: 170,
    },
    height: 165,
    // height: 175,
    borderTopRightRadius: 5,
    borderTopLeftRadius: 5,
    objectFit: 'cover',
  },
  darkenLayer: {
    opacity: 0,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    height: 195,
    borderRadius: 5,
    display: 'block',
    position: 'absolute',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    transition: 'all 0.6s ease 0s',
  },
  playerIcon: {
    position: 'absolute',
    padding: '0px 0px 0px 16px',
    marginTop: -38,
    zIndex: 999,
    marginLeft: 27,
    [theme.breakpoints.down('xs')]: {
      marginLeft: 11,
    },
    [theme.breakpoints.between('310', '360')]: {
      marginLeft: 10,
    },
    [theme.breakpoints.between('375', '410')]: {
      marginLeft: 12,
    },
    [theme.breakpoints.between('410', '440')]: {
      marginLeft: 24,
    },
    [theme.breakpoints.between('440', '480')]: {
      marginLeft: 31,
    },
    [theme.breakpoints.between('480', '520')]: {
      marginLeft: 41,
    },
    [theme.breakpoints.between('520', '560')]: {
      marginLeft: 51,
    },
    [theme.breakpoints.between('560', '600')]: {
      marginLeft: 63,
    },
  },
  icon: {
    width: 44,
    height: 44,
    fill: '#fff',
    // marginTop: 35,
    background: '#ff0066',
    borderRadius: '50%',
  },
  outerCircle: {
    display: 'flex', flex: '1 1 0%',
    minWidth: 216,
    height: 40,
    zIndex: 999,
    marginTop: -15,
    position: 'absolute',
    // backgroundPosition: 'bottom left, bottom right, top right, top left',
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat',
    // boxShadow: '0 -5px 8px -7px #333',
    background: `-webkit-radial-gradient(30% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.outerCircle} 27px)`,
    [theme.breakpoints.down('xs')]: {
      minWidth: 173,
      background: `-webkit-radial-gradient(28% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.outerCircle} 27px)`,
    },
    [theme.breakpoints.between('310', '350')]: {
      minWidth: 157,
      background: `-webkit-radial-gradient(30% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.outerCircle} 27px)`,
    },
    [theme.breakpoints.between('350', '365')]: {
      minWidth: 164,
      background: `-webkit-radial-gradient(29% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.outerCircle} 27px)`,
    },
    [theme.breakpoints.between('393', '410')]: {
      minWidth: 177,
      background: `-webkit-radial-gradient(28% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.outerCircle} 27px)`,
    },
    [theme.breakpoints.between('410', '440')]: {
      minWidth: 185,
      background: `-webkit-radial-gradient(33% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.outerCircle} 27px)`,
    },
    [theme.breakpoints.between('440', '480')]: {
      minWidth: 195,
      background: `-webkit-radial-gradient(35% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.outerCircle} 27px)`,
    },
    [theme.breakpoints.between('480', '520')]: {
      minWidth: 205,
      background: `-webkit-radial-gradient(38% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.outerCircle} 27px)`,
    },
    [theme.breakpoints.between('520', '560')]: {
      minWidth: 215,
      background: `-webkit-radial-gradient(41% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.outerCircle} 27px)`,
    },
    [theme.breakpoints.between('560', '600')]: {
      minWidth: 250,
      background: `-webkit-radial-gradient(40% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.outerCircle} 27px)`,
    },
  },
  detailsContainer: {
    padding: '0px 6px',
    /*position: 'relative',
    marginTop: -3,
    background: theme.palette.modalColor,*/
    '&:last-child': {
      paddingBottom: theme.spacing(1),
      margin: '0px 8px',
    }
  },
  contentShort: {
    color: theme.palette.textColor1,
    fontFamily: 'Arial',
    '& .line-clamp': {
      height: 20,
      marginTop: 0,
      marginLeft: 15,
      color: theme.palette.textColor2,
      fontSize: 11,
      fontFamily: 'Roboto',
      lineHeight: '18px',
      display: 'block',
      position: 'relative',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      transition: 'all 0.3s ease',
    },
  },
  textWrapper: {

  },
  detailsTitle: {
    fontSize: 14,
    maxHeight: 35,
    lineHeight: '16px',
    overflow: 'hidden',
    fontFamily: 'Arial',
    color: theme.palette.textColor1,
  },
  actionOptions: {
    textAlign: 'right',
  },
  defaultImageTitle: {
    top: 5,
    width: 195,
    fontSize: 13,
    color: '#fff',
    padding: '0 5px',
    position: 'absolute',
    display: 'block',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    [theme.breakpoints.down('xs')]: {
      width: 160,
    },
  },
  defaultTitle: {
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
  },
  locator: {
    marginTop: 5,
    border: '3px solid #ff0066',
    position: 'absolute',
    borderRadius: '100%',
    background: '#ff0066',
  },
}));

const DetailsGridItem = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesXS = useMediaQuery(theme.breakpoints.down('xs'));
  const style = {
    width: 25,
    height: 25,
    zIndex: 999,
    marginTop: -20,
    // fill: theme.palette.pink,
  };

  const {
    title,
    subtitle,
    image,
    userhistoryRadioState: { heartedStationIds },
  } = props;
  const [defaultImage, setDefaultImage] = useState(false);

  // const isHearted = props?.history?.star;
  const isHearted = heartedStationIds
      ? heartedStationIds.some(
          (stationId) => stationId === props.stationid
      )
      : false;

  const onMediaFallback = (event) => {
    if (matchesXS) {
      event.target.src = radioImgXS;
    } else {
      event.target.src = radioImg;
    }
    setDefaultImage(true);
  };

  const onClickHandler = () => {
    props.onClick(props.stationid);
  };

  const onFavouriteClickHandler = (event) => {
    event.stopPropagation();
    event.preventDefault();
    props.onFavouriteClick(props.stationid);
  };

  return (
    <Card className={classes.listItem} raised={false} onClick={onClickHandler}>
      <CardActionArea>
        <div className={classes.cardWrapper}>
          <CardMedia
            alt={title}
            component="img"
            className={classes.cardImage}
            src={image}
            onError={onMediaFallback}
          />
          {/*{defaultImage && (
            <div
              className={clsx('defaultImageTitle', classes.defaultImageTitle)}
            >
              <Grid className={classes.defaultTitle}>{title}</Grid>
            </div>
          )}*/}
          <div className={clsx('darkenLayer', classes.darkenLayer)}>
            {/*<Grid container justify="center">
              <PlayCircleFilledIcon className={classes.icon}/>
            </Grid>*/}
          </div>
        </div>
      </CardActionArea>
      <div className={clsx('outerCircle', classes.outerCircle)} />
      <CardContent className={classes.playerIcon}>
        <Grid container justify="center">
          <PlayArrowIcon className={classes.icon}/>
        </Grid>
      </CardContent>
      <CardContent className={clsx(classes.detailsContainer)}>
        <div className={classes.actionOptions}>
          {/*<GlobalClick globalClick={props.radio.clickcount} />*/}
          {/*{!props.hearted &&*/}
          <HeartButton
            style={style}
            name={'Radio'}
            heart={props.heart}
            isHearted={isHearted}
            onFavouriteClickHandler={onFavouriteClickHandler}
          />
          {/*}*/}
        </div>
        <div className={classes.textWrapper}>
          <div className={classes.detailsTitle}>{title}</div>
          <div className={classes.contentShort}>
            {props.radio.state && !matchesXS && <span className={clsx('locator', classes.locator)} />}
            <span
              className="line-clamp"
              dangerouslySetInnerHTML={{ __html: props.radio.state }}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default container(DetailsGridItem);
